define(
    [
        'jquery',
        './lib/position-utils'
    ],
    function (
        $,
        Utils
    ) {
        'use strict';

        var Consts = {
            ESCAPE_KEY: 27
        };

        var defaults = {
            trigger: '[data-detached-dropdown-trigger]',
            content: '[data-detached-dropdown-content]',
            selector: '[data-detached-dropdown]',                 // used to close other dropdowns
            noCloseSelector: '[data-detached-dropdown-no-close]', // Apply to elements that shouldn't close the dropdown
            location: 'down-left',                                // direction-alignment (e.g. down-left)
            isForced: false,                                      // Force a location
            spacing: 10                                           // in pixels (space from target)
        };

        var DetachedDropdown = function(el, options) {
            this.$el = $(el);

            if (this.$el.attr('data-detached-dropdown-applied')) {
                return null;
            } else {
                this.$el.attr('data-detached-dropdown-applied', true);
            }

            this.options = $.extend({}, defaults, options);

            this.$content = this.$el.find(this.options.content);
            this.$trigger = this.$el.find(this.options.trigger);

            // Use data attribute as default location
            this.options.location = this.$el.data('detachedDropdownLocation') ||
                this.options.location;

            if (this.$el[0].hasAttribute('data-detached-dropdown-location-forced')) {
                this.options.isForced = true;
            }

            this.orderedLocations = Utils.getOrderedLocations(this.options.location);
            this.attachEvents();
            this.createTip();
            this.positionDropdown();
        };

        DetachedDropdown.createAll = function(selector, options) {
            var dropdowns = [];
            $(selector).each(function(idx, el) {
                dropdowns.push(new DetachedDropdown(el, options));
            });
            return dropdowns;
        };

        DetachedDropdown.prototype = {

            createTip: function() {
                this.$tip = $('<span data-detached-dropdown-tip />');
                this.$tip.addClass('detached-dropdown__tip');
                this.$content.append(this.$tip);
            },

            attachEvents: function() {
                this.$trigger.on('click', this.closeAll.bind(this));
                this.$trigger.on('click', this.toggle.bind(this));
                this.$content.on('click', this.close.bind(this));
                this.$el.on('close', this.close.bind(this));

                this.bodyClickListener = this.handleBodyClick.bind(this);
                this.escapeListener = this.handleEscape.bind(this);

                $(document).on('click', this.bodyClickListener);
                $(document).on('keydown', this.escapeListener);
            },

            teardown: function() {
                this.$trigger.off('click');
                this.$content.off('click');
                this.$el.off('close');

                $(document).off('click', this.bodyClickListener);
                $(document).off('keydown', this.escapeListener);
            },

            toggle: function(e) {
                if (this.isActive()) {
                    this.close(e);
                } else {
                    this.open(e);
                }
            },

            open: function() {
                this.$content.fadeIn({
                    duration: 200,
                    start: function () {
                        this.positionDropdown();
                    }.bind(this)
                });

                this.$el.attr('data-detached-dropdown-state', 'active');
            },

            close: function(e) {
                if ($(e.target).is(this.options.noCloseSelector) ||
                    $(e.target).closest(this.options.noCloseSelector).length > 0) {
                    return;
                }

                this.$content.fadeOut(200, function() {
                    this.$el.trigger('closed');
                }.bind(this));

                this.$el.attr('data-detached-dropdown-state', 'inactive');
            },

            closeAll: function() {
                var $items = $(this.options.selector).not(this.$el);

                $items.each(function(idx, item) {
                    $(item).trigger('close');
                });
            },

            handleEscape: function(e) {
                if (e.which === Consts.ESCAPE_KEY) {
                    this.close(e);
                }
            },

            handleBodyClick: function(e) {
                if (this.isActive()) {
                    if (!$.contains(this.$el[0], e.target)) {
                        this.close(e);
                    }
                }
            },

            isActive: function() {
                return this.$el.is("[data-detached-dropdown-state='active']");
            },

            // FIXME - where does this live and it needs big time tests.
            getDropdownBox: function() {
                var containerRect = this.$el[0].getBoundingClientRect();
                var originRect = this.$trigger[0].getBoundingClientRect();
                var contentRect = this.$content[0].getBoundingClientRect();
                var spacing = this.options.spacing;
                var box;

                // Cycle through a pre-ordered list of possible locations
                // and attempt to determine if a given box will fit on a viewport.
                this.orderedLocations.every(function(location) {

                    box = Utils.createBox(
                        originRect,
                        contentRect,
                        location,
                        spacing
                    );

                    if (this.options.isForced) {
                        return false;
                    } else {
                        // Check if rectangle is out of bounds on screen.
                        return Utils.isRectOutOfBounds(box, {
                            width: $(window).width(),
                            height: $(window).height()
                        });
                    }
                }.bind(this));

                // FIXME - test. (this is positioning the content relative to the container)
                box.top = box.top - containerRect.top;
                box.left = box.left - containerRect.left;

                return box;
            },

            positionDropdown: function(resetWidth) {
                var box = this.getDropdownBox();
                var width;
                var tipPosition;

                if (resetWidth === undefined) {
                    resetWidth = false;
                }

                this.$el.attr('data-detached-dropdown-location', box.location);

                if (box.alignment !== 'fluid') {
                    if (resetWidth) {
                        this.$content.css('width', '');
                    }

                    // Round up width up and add 1px to prevent edge case wrapping
                    width = Math.ceil(this.$content.width());

                    if (width > 0) {
                        this.$content.css('width', width);
                    }
                }

                this.$content.css({
                    top: box.top,
                    left: box.left
                });

                tipPosition = this.getTipPosition(box);

                this.$tip.css({
                    left: tipPosition.left
                });
            },

            getTipPosition: function(position) {
                var tipPosition = {};
                var triggerRect = this.$trigger[0].getBoundingClientRect();
                var contentRect = this.$content[0].getBoundingClientRect();

                if (position.alignment !== 'fluid') {
                    switch (position.alignment) {
                    case 'left':
                        tipPosition.left = (triggerRect.width > contentRect.width) ? '50%' : triggerRect.width / 2;
                        break;
                    case 'center':
                        tipPosition.left = '50%';
                        break;
                    case 'right':
                        tipPosition.left = (triggerRect.width > contentRect.width) ? '50%' : contentRect.width - (triggerRect.width / 2);
                        break;
                    }
                } else {
                    tipPosition.left = (triggerRect.left + (triggerRect.width / 2)) - contentRect.left;
                }

                return tipPosition;
            }
        };

        return DetachedDropdown;
    }
);



// WEBPACK FOOTER //
// ./~/@99designs/asimov/detached-dropdown/index.js